import React__default, { useState, useRef, useEffect } from 'react';
import styled from '@emotion/styled';
import { SvgIcon } from '@teko/ui';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAX_PRICE = 1e11;
const StyledInput = styled.input(({ error, allowClear, prefixIcon, disabled, theme: { colors } }) => `
    //Remove input shadow on IOS Safari
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    box-sizing: border-box;
    margin: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnum';
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 10px;
    color: ${colors.text};
    font-size: 14px;
    line-height: 1.5715;
    background-image: none;
    border: 1px solid
      ${!!error ? colors.error : colors.border} !important;
    border-radius: 4px;
    transition: all 0.3s;
    ${allowClear ? "padding-right: 32px" : ""};
    ${prefixIcon ? "padding-left: 36px" : ""};
    ${!disabled ? "background-color: #fff" : ""};

    &:hover {
      border-color: ${!!error ? colors.error : "#40a9ff"};
    }

    &:focus {
      border-color: ${!!error ? colors.error : "#40a9ff"};
      border-right-width: 1px !important;
      outline: 0;
      box-shadow: 0 0 0 2px
        ${!!error ? "rgba(255,77,79,.2)" : "rgba(24, 144, 255, 0.2)"};
    }
  `);
const InputContainer = styled.div`
  position: relative;
`;
const ClearIcon = styled(SvgIcon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.75rem;
  width: 1.25rem;
  height: 1.25rem;
  background-color: #bbb;
`;
const Label = styled.label(({ required, theme }) => `
    margin-bottom: 0.4rem;
    font-weight: 500;
    &::before {
      content: '*';
      display: ${required ? "inline-block" : "none"};
      margin-right: 4px;
      color: ${theme == null ? void 0 : theme.colors.error};
      font-size: 14px;
      width: max-content;
    }
  `);
const Error2 = styled.div(({ theme }) => `
    padding-top: 0;
    color: ${theme == null ? void 0 : theme.colors.error500};
    font-size: 0.75rem;
    line-height: 1rem;
    transition: color 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    margin-top: 0.5rem;
  `);
const PrefixIcon = styled(SvgIcon)`
  position: absolute;
  top: 5px;
  left: 10px;
  cursor: pointer;
  z-index: 1;
`;
const Currency = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.75rem;
`;
const Wrapper = styled.div`
  margin-bottom: 1rem;
`;
function resolveOnChange(target, e, onChange) {
  if (onChange) {
    let event = e;
    if (e.type === "click") {
      event = Object.create(e);
      event.target = target;
      event.currentTarget = target;
      const originalInputValue = target.value;
      target.value = "";
      onChange(event);
      target.value = originalInputValue;
      return;
    }
    onChange(event);
  }
}
const formatCurrency = (money) => {
  return money ? money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : `${money}`;
};
const LegacyInput = (_a) => {
  var _b = _a, {
    value,
    allowClear = true,
    label,
    required,
    error,
    name,
    prefixIcon,
    isFocused,
    allowFocus,
    inputType,
    currency,
    className,
    onChange
  } = _b, restProps = __objRest(_b, [
    "value",
    "allowClear",
    "label",
    "required",
    "error",
    "name",
    "prefixIcon",
    "isFocused",
    "allowFocus",
    "inputType",
    "currency",
    "className",
    "onChange"
  ]);
  const [internalValue, setInternalValue] = useState("");
  const textInputRef = useRef(null);
  useEffect(() => {
    if (inputType === "price") {
      setInternalValue(formatCurrency(String(value)));
    } else {
      setInternalValue(value);
    }
  }, [value]);
  const handlePriceInput = (value2) => {
    value2 = value2.replace(/\./g, "");
    if (/^\d*$/.test(value2))
      return value2;
    return null;
  };
  const handleChange = (e) => {
    let value2 = e.target.value;
    if (inputType === "price") {
      value2 = handlePriceInput(value2);
      if (value2 !== null && textInputRef.current !== null) {
        if (Number(value2) > MAX_PRICE) {
          value2 = String(MAX_PRICE);
        }
        e.target.value = value2;
        resolveOnChange(textInputRef.current, e, onChange);
      }
    } else {
      if (textInputRef.current !== null) {
        setInternalValue(value2);
        resolveOnChange(textInputRef.current, e, onChange);
      }
    }
  };
  const handleClear = (e) => {
    if (textInputRef.current) {
      setInternalValue("");
      textInputRef.current.focus();
      resolveOnChange(textInputRef.current, e, onChange);
    }
  };
  useEffect(() => {
    if (textInputRef.current && isFocused) {
      textInputRef.current.focus();
    }
  }, [isFocused]);
  return /* @__PURE__ */ React__default.createElement(Wrapper, {
    className
  }, label && /* @__PURE__ */ React__default.createElement(Label, {
    className: "input__label",
    required
  }, label), /* @__PURE__ */ React__default.createElement(InputContainer, null, prefixIcon && /* @__PURE__ */ React__default.createElement(PrefixIcon, {
    name: prefixIcon,
    size: 22
  }), /* @__PURE__ */ React__default.createElement(StyledInput, __spreadProps(__spreadValues({
    name,
    label,
    value: internalValue,
    allowClear,
    onChange: handleChange,
    ref: textInputRef,
    error,
    prefixIcon,
    required
  }, restProps), {
    className: "input__input"
  })), allowClear && !!internalValue && /* @__PURE__ */ React__default.createElement(ClearIcon, {
    name: "circle-close",
    onClick: handleClear
  }), !!currency && /* @__PURE__ */ React__default.createElement(Currency, null, currency)), !!error && /* @__PURE__ */ React__default.createElement(Error2, {
    className: "input__error"
  }, error));
};

export { LegacyInput };
